import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-pencil',
  imports: [],
  template: `<svg
  width="16"
  height="16"
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M2.87716 12.5021C2.8197 12.5027 2.76269 12.4919 2.70941 12.4704C2.65613 12.4489 2.60763 12.417 2.5667 12.3767C2.51978 12.3304 2.48367 12.2742 2.46096 12.2123C2.43826 12.1504 2.42951 12.0842 2.43535 12.0185L2.62043 9.72587C2.62837 9.6194 2.67511 9.51955 2.75178 9.44526L9.35503 2.84202C9.72295 2.49748 10.2125 2.31284 10.7163 2.32857C11.2168 2.33245 11.6971 2.5267 12.0596 2.87187C12.4073 3.2289 12.6073 3.70411 12.6194 4.20232C12.6316 4.70053 12.4551 5.18495 12.1253 5.55854L5.51607 12.1916C5.4421 12.2653 5.34524 12.3117 5.24143 12.323L2.91895 12.5319L2.87716 12.5021ZM3.4742 9.95871L3.34882 11.5946L4.98471 11.4453L11.4924 4.92568C11.6193 4.77551 11.7004 4.59208 11.7261 4.39717C11.7518 4.20226 11.721 4.00407 11.6374 3.82614C11.5538 3.64822 11.4209 3.49803 11.2544 3.39343C11.0879 3.28883 10.8949 3.23421 10.6984 3.23606C10.5692 3.22786 10.4396 3.24584 10.3175 3.28893C10.1954 3.33202 10.0833 3.39933 9.98789 3.48682V3.48682L3.4742 9.95871Z"
    [attr.fill]="color"
  />
</svg>
`
})
export class PencilComponent {
  @Input() color: string = '#043B22';
}
